export enum Operator {
  TURKCELL = 'TURKCELL',
  VODAFONE = 'VODAFONE',
  TT = 'TT',
  UNKNOWN = 'UNKNOWN',
}
